module.exports = __webpack_public_path__ + "img/kushki.d40f19b0.png";